// Compact BNPL messaging on product pages (Afterpay / Square placement shadow DOM)
(function () {
  if (!window.location.pathname.includes('/products/')) return;

  var HOST_SELECTORS = '.payment-options-block afterpay-placement, .payment-options-block square-placement';

  function styleWidget(widget) {
    if (!widget || !widget.shadowRoot) return;
    if (widget.shadowRoot.querySelector('style[data-aor-bnpl]')) return;

    widget.style.setProperty('--messaging-font-size', '14px');
    widget.style.setProperty('--logo-badge-width', '64px');

    var style = document.createElement('style');
    style.setAttribute('data-aor-bnpl', 'true');
    style.textContent =
      ':host { --messaging-font-size: 14px !important; --logo-badge-width: 64px !important; }' +
      ':host, :host > * { max-width: 100%; }' +
      ':host [class*="container"], :host [class*="messaging"], :host [class*="wrapper"] {' +
      '  display: inline !important; flex-wrap: nowrap !important; align-items: center !important;' +
      '  white-space: normal !important; line-height: 1.4 !important;' +
      '}' +
      ':host [class*="logo"], :host [class*="badge"] {' +
      '  display: inline-flex !important; vertical-align: middle !important;' +
      '  max-height: 20px !important; height: auto !important;' +
      '}';
    widget.shadowRoot.appendChild(style);
  }

  function scan() {
    var price = document.querySelector('[data-product-price]');
    var amount = price ? Number(price.textContent.replace(/[^0-9.]/g, '')) : NaN;
    document.querySelectorAll(HOST_SELECTORS).forEach(function (widget) {
      // The provider watches data-amount, including its modal and limit rules.
      // Observe only our product price, rather than every mutation on the page.
      if (price && price.textContent.trim() && Number.isFinite(amount) && amount >= 0) {
        var nextAmount = amount.toFixed(2);
        if (widget.getAttribute('data-amount') !== nextAmount) widget.setAttribute('data-amount', nextAmount);
      }
      styleWidget(widget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  setTimeout(scan, 500);
  setTimeout(scan, 1500);
  setTimeout(scan, 3000);

  if (typeof MutationObserver !== 'undefined') {
    var container = document.querySelector('[data-payment-options]');
    if (container) {
      new MutationObserver(scan).observe(container, { childList: true, subtree: true });
    }
    var price = document.querySelector('[data-product-price]');
    if (price) new MutationObserver(scan).observe(price, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('aor:payment-messaging-ready', scan);
})();
